import { Injectable, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../models/user';
import { AuthApiService } from './apis/auth-api.service';
import { TawkService } from './tawk.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  profile: WritableSignal<User | null> = signal<User | null>(null);
  constructor(
    private authApi: AuthApiService,
    private router: Router,
    private tawkService: TawkService
  ) {}

  setProfile(user: User | null): void {
    this.profile.set(user);
    if (user) {
      this.tawkService.setVisitor(user);
    } else {
      this.tawkService.logout();
    }
  }

  async getProfile(): Promise<User | null> {
    try {
      const r = await this.authApi.getProfile();
      this.setProfile(r);
      return r;
    } catch (error) {}
    return null;
  }

  async logout(): Promise<void> {
    try {
      await this.authApi.logout();
      this.setProfile(null);
      this.router.navigate(['/']);
    } catch (error) {}
  }
}
